export const EMAIL_EMPTY = "Don't forget enter in your Email."
export const EMAIL_INVALID = 'Hmmm...Email or Password is incorrect.'
export const PASSWORD_EMPTY = 'Pssst! You left Password field blank.'
export const SERVER_ERROR = 'System is acting up, try again later.'
export const USERNAME_EMPTY = 'How you want to be referred as.'
